import React from 'react'
import { Flex, FlexProps, ScaleFade, useDisclosure } from '@chakra-ui/react'
import { gql } from '@urql/core'
import { isServerSide } from 'lib/env'
import useQuery from 'hooks/useQuery'
import { useVertical } from 'hooks/useVerticalData'
import { NewsLetter } from 'containers/blogs/components/newsletter/components/NewsLetter'
import { NewsLetterSubmitted } from 'containers/blogs/components/newsletter/components/NewsLetterSubmitted'

export const QUERY_ASSOCIATED_TAGS = gql`
    query associated_tags($vertical: vertical!, $limit: Int) {
        associated_tags(vertical: $vertical, limit: $limit) {
            results {
                id
                label
            }
        }
    }
`

export const NewsLetterWrapper = ({
    isSubmitted,
    ...flexProps
}: { isSubmitted?: boolean } & FlexProps) => {
    const { isOpen, onToggle } = useDisclosure({
        defaultIsOpen: !isSubmitted,
    })

    const vertical = useVertical()
    const [result] = useQuery({
        query: QUERY_ASSOCIATED_TAGS,
        variables: {
            // TODO: [BUG-CU-2d4r62n] www vertical returns no tag so we have to use functional for now.
            vertical: vertical === 'www' ? 'functional' : vertical,
            limit: 15,
        },
        pause: isServerSide,
    })

    const tags = result?.data?.associated_tags?.results ?? []

    if (tags.length === 0) {
        return null
    }

    const commonProps = {
        justify: 'center',
        pt: { base: '36px', md: '48px ' },
        pb: { base: '20px', md: '55px ' },
        px: { base: '16px ', md: '56px' },
        borderRadius: '12px',
        backgroundColor: 'gray.background',
    }

    return (
        <>
            <ScaleFade initialScale={1} in={isOpen}>
                {isOpen && (
                    <Flex width="100%" {...commonProps} {...flexProps}>
                        <NewsLetter tags={tags} setOnSubmit={onToggle} />
                    </Flex>
                )}
            </ScaleFade>
            <ScaleFade initialScale={1} in={!isOpen}>
                {!isOpen && (
                    <Flex
                        direction={{ base: 'column', md: 'row' }}
                        align="center"
                        gridGap="22px"
                        {...commonProps}
                        {...flexProps}
                    >
                        <NewsLetterSubmitted />
                    </Flex>
                )}
            </ScaleFade>
        </>
    )
}
